<template>
  <img :src="logo[itemName]" :width="mwidth" :alt="logo.alt" />
</template>

<script>
import logos from '@/components/navigation/logos.js'

export default {
  props: {
    reverse: Boolean,
    width: Number
  },
  data () {
    return {
      mwidth: 177,
      itemName: 'logo'
    }
  },
  created () {
    if(this.width) {
      this.mwidth = this.width
    }
    if(this.reverse){
      this.itemName = 'logoRev'
    }
  },
  computed: {
    logo () {
      if(this.animation) {
        return logos.anim
      }
      return logos.illus
    },
    animation () {
      return this.$k.isAnimationRoute(this.$route.path)
    }
  },
  watch: {
    width () {
      this.mwidth = this.width
    },
    reverse() {
      if(this.reverse) {
        this.itemName = 'logoRev'
      }
      else {
        this.itemName = 'logo'
      }
    }
  }
}
</script>

<style>

</style>